import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles/utils/fill";
export const ArbitrumNovaLogo = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M8.326 3.855H6.128a.361.361 0 0 0-.34.237L.012 19.902a.18.18 0 0 0 .17.242h2.198a.361.361 0 0 0 .34-.237l5.777-15.81a.18.18 0 0 0-.17-.242Zm2.673 6.624a.18.18 0 0 0-.339 0L9.52 13.6a.36.36 0 0 0 0 .246l2.216 6.062a.361.361 0 0 0 .34.237h2.197a.18.18 0 0 0 .17-.242l-3.444-9.423Zm5.604 3.053a.18.18 0 0 0 .34 0l3.447-9.435a.18.18 0 0 0-.17-.242h-2.198a.361.361 0 0 0-.34.237l-2.219 6.074a.36.36 0 0 0 0 .247l1.14 3.12ZM12.269 4.09a.358.358 0 0 0-.337-.235H9.727a.361.361 0 0 0-.34.237L3.61 19.902a.18.18 0 0 0 .17.242h2.198a.361.361 0 0 0 .34-.237L10.74 7.802a.09.09 0 0 1 .17 0l4.424 12.105a.361.361 0 0 0 .339.237h2.198a.18.18 0 0 0 .17-.242L12.269 4.09Zm11.55-.235h-2.198a.361.361 0 0 0-.34.237L17.264 15.09a.36.36 0 0 0 0 .247l1.14 3.12a.18.18 0 0 0 .339 0L22.72 7.568l1.269-3.472a.18.18 0 0 0-.17-.242Z" fill={fillAttribute} fillRule="nonzero" />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};